import React from 'react';
import { Link } from 'react-router-dom';
import { LogoIcon, MailIcon, PhoneIcon, MapPinIcon, LinkedInIcon, TwitterIcon, FacebookIcon } from '../icons/Icons';
import { useSettings } from '../../context/SettingsContext';
import './Footer.css';

const Footer = () => {
  const { settings } = useSettings();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/portfolio', label: 'Our Portfolio' },
    { path: '/impact', label: 'Impact & Community' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact Us' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              {settings.logo_footer_url ? (
                <img src={settings.logo_footer_url} alt={settings.site_name || 'Fuwali'} className="footer-logo-img" />
              ) : (
                <>
                  <LogoIcon size={50} />
                  <div className="footer-logo-text">
                    <span className="footer-logo-name">Fuwali</span>
                    <span className="footer-logo-tagline">Investments Zambia</span>
                  </div>
                </>
              )}
            </Link>
            <p className="footer-description">
              A diversified investment holding company fostering innovative, impact-driven investment solutions that uplift communities and contribute to national progress.
            </p>
          </div>

          <div className="footer-links">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-list">
              {quickLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contact">
            <h4 className="footer-title">Contact Us</h4>
            <ul className="footer-list">
              <li className="footer-contact-item">
                <MailIcon size={18} />
                <a href={`mailto:${settings.footer_email}`}>{settings.footer_email}</a>
              </li>
              <li className="footer-contact-item">
                <PhoneIcon size={18} />
                <a href={`tel:${settings.footer_phone}`}>{settings.footer_phone}</a>
              </li>
              <li className="footer-contact-item">
                <MapPinIcon size={18} />
                <span>{settings.footer_address}</span>
              </li>
            </ul>
          </div>

          <div className="footer-social">
            <h4 className="footer-title">Follow Us</h4>
            <div className="footer-social-links">
              {settings.social_linkedin && (
                <a href={settings.social_linkedin} target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="LinkedIn">
                  <LinkedInIcon size={20} />
                </a>
              )}
              {settings.social_twitter && (
                <a href={settings.social_twitter} target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Twitter">
                  <TwitterIcon size={20} />
                </a>
              )}
              {settings.social_facebook && (
                <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Facebook">
                  <FacebookIcon size={20} />
                </a>
              )}
              {!settings.social_linkedin && !settings.social_twitter && !settings.social_facebook && (
                <>
                  <span className="footer-social-link" aria-label="LinkedIn"><LinkedInIcon size={20} /></span>
                  <span className="footer-social-link" aria-label="Twitter"><TwitterIcon size={20} /></span>
                  <span className="footer-social-link" aria-label="Facebook"><FacebookIcon size={20} /></span>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{settings.footer_copyright}</p>
          <p className="footer-developer">
            Developed by <a href="https://www.negociokonnect.com" target="_blank" rel="noopener noreferrer">Negocio Konnect</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
